import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import TestimonialsPage from "./pages/TestimonialsPage";
import BackgroundMusic from "./components/BackgroundMusic";

const AppContent = () => {
  const location = useLocation();
  const hideMusic = location.pathname === '/testimonials';
  return (
    <>
      {!hideMusic && <BackgroundMusic />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/testimonials" element={<TestimonialsPage />} />
      </Routes>
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </div>
  );
}

export default App;
